import { createSlice } from "@reduxjs/toolkit";

export const loadingSlice = createSlice({
  name: "loading",
  initialState: { list: false, editModal: false, linesLoading: false },
  reducers: {
    loadingIndicatorOn: (state) => ({ ...state, list: true }),
    loadingIndicatorOff: (state) => ({ ...state, list: false }),
    editModalLoadingIndicatorOn: (state) => ({ ...state, editModal: true }),
    editModalLoadingIndicatorOff: (state) => ({ ...state, editModal: false }),
    linesLoadingOn: (state) => ({
      ...state,
      linesLoading: true,
      editModal: true,
    }),
    linesLoadingOff: (state) => ({
      ...state,
      linesLoading: false,
      editModal: false,
    }),
  },
});

export const {
  loadingIndicatorOn,
  loadingIndicatorOff,
  editModalLoadingIndicatorOn,
  editModalLoadingIndicatorOff,
  linesLoadingOn,
  linesLoadingOff,
} = loadingSlice.actions;
export default loadingSlice.reducer;
